<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IfpIHk/tc-custom/9781398430563.jpg?1705687990138" alt="This image is the cover for the book The Yellow House, Susceptible to Broken Windows"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Yellow House, Susceptible to Broken Windows
      </h1>
      <p class="bookDescription body article font2">
        <p>Where to begin… Take a moment to breathe. The door isn’t yellow, I know. “It’s infuriating.” We know it’s infuriating, Paul, but we’ve only just arrived. “I haven’t even been given any directions. How am I going to find her office?” It’s unlikely that you will. He hasn’t even crossed the threshold and the complaining has begun. What will he say to her yellow stripe, to the cannon on the roof and the politics found in the halls? It’s hard to imagine but it won’t be hard for long. Open the door and you’ll feel the love. Paul might cringe time and time again, but we hope you’ll feel differently. The mind boggles, the stomach reels and the knees quake, come and feel for yourself. Madam President welcomes you with open arms.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniel Raybould
      </h2>
      
      <p class="authorDescription body article">This is Daniel’s second novel. He began work on it when he was still finishing his first and then came back to it at a later date to work on it further, in the hope that the novel would grow into a deeply developed and thoroughly thought about story. He fell in love with the Yellow House family and the environment in which the family lived out their lives as he continued to write and edit. He began to read and write when he was seventeen, having previously never picked up a book with the intent of reading or finishing one. Now, both reading and writing are a firm passion of his.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a55ce1e6